import React from "react";
import { useSelector } from "react-redux";

export default function PreLoader(props) {
  const { switch_theme } = useSelector((state) => state.AuthReducer);
  return (
    <div>
      <div id="preloader">
        <div className="preload-content">

          {/* <div id="dream-load"></div> */}
          <img
            src={switch_theme === "dark" ? "/img/logo.png" : "/img/logo_dark.png"}
            alt=""
            style={{ width: '80px', marginBottom: '10px' }}
          />
          <span className="loader" style={{filter: switch_theme === "light" ? "invert(1)" : ""}}></span>
        </div>

      </div>
    </div>
  );
}
